import { type ReactNode, useContext } from 'react';

import { Context } from './Context.tsx';

export const useActions = (): ReactNode | undefined => {
  const { actions } = useContext(Context);
  return actions;
};
